export const mockData = {
  stats: [
    { value: "15+", label: "Years Experience" },
    { value: "UK-wide", label: "Coverage" },
    { value: "1", label: "Operational Facility" },
    { value: "24/7", label: "Access Available" }
  ],
  
  featuredProjects: [
    {
      name: "Current Operations",
      status: "Operational",
      description: "Our existing premier cemetery and crematorium facility demonstrates our commitment to exceptional care and beautiful memorial spaces.",
      features: [
        "FBCA regular inspections",
        "ICCM professional standards",
        "Energy-efficient solar systems",
        "Multi-faith inclusive services",
        "Professional landscaping"
      ]
    },
    {
      name: "The National Memorial Garden",
      status: "In Development",
      location: "Great Hallingbury, Hertfordshire",
      description: "Our flagship £3 million development near M11, M25, and M1 motorways, featuring innovative four-season design themes.",
      features: [
        "Four seasonal themed areas",
        "Contemporary chapel facilities",
        "Tranquil water features",
        "Accessible design throughout",
        "On-site visitor amenities"
      ]
    }
  ],

  services: [
    {
      category: "Development Services",
      items: [
        {
          title: "Site Development",
          description: "Comprehensive planning and development of memorial garden sites from conception to completion.",
          features: ["Planning permission", "Landscape architecture", "Infrastructure development", "Environmental compliance"]
        },
        {
          title: "Design & Architecture",
          description: "Creating beautiful, functional spaces that serve as parks for the living while honoring the departed.",
          features: ["Landscape design", "Seasonal theming", "Accessibility planning", "Sustainable features"]
        },
        {
          title: "Partnership Management",
          description: "Establishing operational partnerships with experienced management teams for ongoing facility operations.",
          features: ["Management selection", "Operational handover", "Quality standards", "Ongoing oversight"]
        }
      ]
    },
    {
      category: "Memorial Options",
      items: [
        {
          title: "Natural Burial Grounds",
          description: "Eco-friendly burial options within beautifully landscaped natural settings.",
          features: ["Native tree planting", "Wildflower meadows", "Biodegradable materials", "Natural memorialization"]
        },
        {
          title: "Memorial Gardens",
          description: "Designed spaces for various memorial preferences including ashes scattering and remembrance.",
          features: ["Dedicated garden areas", "Memorial trees", "Commemorative plaques", "Reflection spaces"]
        },
        {
          title: "Water Features",
          description: "Tranquil water elements that provide peaceful reflection spaces within our developments.",
          features: ["Memorial fountains", "Reflection pools", "Stream features", "Aquatic gardens"]
        }
      ]
    }
  ],

  masterplanSeasons: [
    {
      name: "Blossom",
      season: "Spring",
      description: "Cherry blossoms and spring flowering trees create a celebration of renewal and hope.",
      features: ["Cherry blossom groves", "Spring bulb displays", "Fresh green landscapes", "Symbol of new beginnings"],
      colorTheme: "Pink and fresh green",
      plantingType: "Ornamental flowering trees"
    },
    {
      name: "Lush",
      season: "Summer",
      description: "Rich green spaces with full canopy trees providing shade and tranquil gathering areas.",
      features: ["Mature canopy trees", "Lush green lawns", "Shaded pathways", "Summer flowering plants"],
      colorTheme: "Deep greens and vibrant growth",
      plantingType: "Deciduous shade trees"
    },
    {
      name: "Amber",
      season: "Autumn",
      description: "Golden and amber foliage creates warm, contemplative spaces for reflection.",
      features: ["Autumn color displays", "Golden leaf canopies", "Warm pathway lighting", "Seasonal memorial gardens"],
      colorTheme: "Golden, amber, and warm oranges",
      plantingType: "Deciduous trees with autumn color"
    },
    {
      name: "Pure",
      season: "Winter",
      description: "Elegant bare branches and evergreen elements provide structural beauty and year-round interest.",
      features: ["Evergreen plantings", "Structural tree forms", "Winter interest plants", "Contemplative spaces"],
      colorTheme: "Whites, greys, and deep greens",
      plantingType: "Evergreen and structural plants"
    }
  ],

  aboutInfo: {
    vision: "To create unparalleled memorial spaces that serve as places for the living to remember, reflect, and find comfort in beautifully designed environments that celebrate life.",
    approach: "As owners and developers, we focus on creating exceptional memorial garden facilities from conception to completion, then partnering with expert management teams for ongoing operations. This allows us to concentrate on what we do best - developing beautiful, innovative spaces.",
    expertise: [
      "Memorial garden planning and development",
      "Landscape architecture and design",
      "Environmental sustainability integration",
      "Partnership and operational management",
      "Regulatory compliance and standards"
    ],
    experience: "15+ years of experience in memorial garden development and management across the UK."
  },

  contactInfo: {
    phone: "020 3576 3018",
    email: "info@fenixpartnership.co.uk",
    address: "UK-wide service with strategic locations",
    hours: "24/7 facility access with staff support during business hours"
  },

  investment: {
    opportunity: "The National Memorial Garden represents a unique £3 million investment opportunity in the growing memorial services sector.",
    projections: {
      investment: "£3 million",
      annualRevenue: "£2.5 million by year three",
      projectedProfit: "£1.75 million annual profit",
      breakEven: "Year four"
    },
    highlights: [
      "Stable market demand - consistent need for memorial services",
      "Premium market position - high-quality offerings in underserved market",
      "Strategic location - Near M11, M25, and M1 for UK-wide accessibility",
      "Experienced team - Industry expertise ensuring successful execution",
      "Growing market - 78% cremation rate with increasing demand for alternatives"
    ]
  }
};